

export const styles = {
  mainContainer:{
    display: "flex",
    width: "100%",
    objectFit: "cover",
    backgroundColor: "pink",
    margin: 0,
    padding: 0,
  },
  imageContainer:{
    display: "flex",
    width: "100%",
    display: "flex",
    backgroundColor:"black",
    margin: 0,
    padding: 0,
  },
  imageStyle:{
    width: "100%",
    height: 700,
    objectFit: "cover",
    margin: 0,
    padding: 0,
  }
}